import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {DomSanitizer} from "@angular/platform-browser";
import {ImageCropperComponent, ImageTransform} from "ngx-image-cropper";
import {SecondaryButtonComponent} from "../secondary-button/secondary-button.component";
import {PrimaryButtonComponent} from "../primary-button/primary-button.component";
import {TranslateModule} from "@ngx-translate/core";
import {NgClass, NgIf} from "@angular/common";


@Component({
  selector: 'app-file-uploader',
  templateUrl: './file-uploader.component.html',
  standalone: true,
  imports: [
    SecondaryButtonComponent,
    PrimaryButtonComponent,
    TranslateModule,
    ImageCropperComponent,
    NgClass,
    NgIf
  ],
  styleUrls: ['./file-uploader.component.scss']
})
export class FileUploaderComponent implements OnInit, OnChanges {


  @ViewChild('fileElement') fileElement: any;

  transform: ImageTransform = {};
  filecontent: any;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  showCropper: boolean = false;
  hasFooter: boolean = true;
  @Output() setImageSource = new EventEmitter();
  @Output() showCropperBlock = new EventEmitter();
  @Output() imageSrc = new EventEmitter();
  @Input() defaultImage = '';
  @Input() initialImage = '';
  @Input() showRemove = true;
  @Input() settings : any;

  constructor(private sanitizer: DomSanitizer) {

  }

  ngOnInit(): void {
    if(!this.settings){
      this.settings ={
        resizeToWidth: 256,
        ratio: 1 / 1,
        roundCropper: false
      }
    }
  }



  clickOnFileElement(){
    this.fileElement.nativeElement.click();
  }




  ngOnChanges(changes: SimpleChanges): void {
    const selfObj = this;
    if (this.initialImage && this.initialImage.length > 0) {

      selfObj.croppedImage = this.sanitize(this.initialImage);
    } else if (this.defaultImage.length > 0) {
      this.toDataURL(this.defaultImage, (dataUrl:string) => {
        if (!selfObj.croppedImage || !selfObj.showRemove) {
          selfObj.defaultImage = dataUrl;
          selfObj.croppedImage = dataUrl;
        }
      });
    }

  }




  toDataURL(url:string, callback:any) {


    const xhr = new XMLHttpRequest();
    xhr.onload = function() {
      const reader = new FileReader();
      reader.onloadend = function() {
        callback(reader.result);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
  }

  getExtension(filename:string) {
    const parts = filename.split('.');
    return parts[parts.length - 1];
  }

  isImage(filename:string) {
    const ext = this.getExtension(filename);
    switch (ext.toLowerCase()) {
      case 'jpg':
      case 'jpeg':
      case 'gif':
      case 'bmp':
      case 'png':
        return true;
    }
    return false;
  }



  fileChangeEvent(event: any): void {
    let isImage = false;

    if (!event.isTrusted) {
      if (event.srcElement) {
        event.srcElement.files = this.filecontent;
        isImage = this.isImage(event.srcElement.files[0].name);
      } else {
        event.originalTarget.files = this.filecontent;
        isImage = this.isImage(event.originalTarget.files[0].name);
      }
    } else {
      if (event.srcElement) {
        this.filecontent = event.srcElement.files;
        isImage = this.isImage(event.srcElement.files[0].name);
      } else {
        this.filecontent = event.originalTarget.files;
        isImage = this.isImage(event.originalTarget.files[0].name);
      }

    }

    if (isImage) {
      if (this.filecontent.length > 0) {
        this.showCropper = true
      }
      this.imageChangedEvent = event;
    } else {
     // this.popupHelper.printError('This format is not supported for image upload');
     }
  }


  confirmChangeForImage() {
    this.imageSrc.emit(this.croppedImage);
  }

  hideCropper(){
    this.showCropperBlock.emit(false)
    this.showCropper = false
    this.fileElement.nativeElement.value= '';
  }



  sanitize(url:string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  imageLoaded() {

    this.showCropperBlock.emit(true)
    // show cropper
  }



  loadImageFailed() {
  }

  disableClick() {
    return false;
  }

  imageCropped(image: any) {
    var reader = new FileReader();
    reader.readAsDataURL(image.blob);
    reader.onloadend =  () => {
      var base64String = reader.result;
      //@ts-ignore
      this.croppedImage = base64String.substr(base64String.indexOf(', ') + 1);
    }
    this.fileElement.nativeElement.value= '';
  }
}
